import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Companies from "@/pages/Companies";
import CompanyDetail from "@/pages/CompanyDetail";
import Products from "@/pages/Products";
import Offers from "@/pages/Offers";
import OfferDetail from "@/pages/OfferDetail";
import Pipeline from "@/pages/Pipeline";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center font-mono-label text-sm text-slate-400">CARICAMENTO...</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="aziende" element={<Companies />} />
              <Route path="aziende/:id" element={<CompanyDetail />} />
              <Route path="catalogo" element={<Products />} />
              <Route path="offerte" element={<Offers />} />
              <Route path="offerte/:id" element={<OfferDetail />} />
              <Route path="pipeline" element={<Pipeline />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
